import React from "react"
import * as NWD from "../style/tjanster-infopage-style"
import * as Lib from "../style/lib"
import { AndtechConsultantSkills } from "../utils/skill-details-konsult"
import { BokaMote } from "../style/bokaMote"
import LM from "../../assets/portraits/LM_portrait.jpg"
// egglogic


const KonsultText = [
  `Med ödmjukhet, nyfikenhet och spetskompetens ser vi till att våra insatser gör skillnad – vare sig det handlar om att leda komplexa projekt, stärka ett team eller finslipa en befintlig lösning. Vi trivs i både strategiska och operativa roller och anpassar oss efter det sammanhang vi kliver in i.`,

  `För oss handlar det om mer än teknik – vi bygger långsiktiga samarbeten där vi utvecklas tillsammans med våra kunder. Vi skapar genomtänkta lösningar som är enkla att använda, vidareutveckla och anpassa efter behov. Oavsett om vi tar fram något nytt eller förfinar en befintlig lösning, ser vi till att tekniken fungerar smidigt i vardagen.`,

  `Vi kliver in där vi behövs, blir en del av teamet och tillsammans ser vi till att tekniken fungerar smidigt idag och är redo för morgondagen. När vi jobbar ihop ska det kännas enkelt, värdeskapande och inspirerande.`

];



export const Konsulter: React.FC = () => {



  return (
    <NWD.WebDevSection>
      <Lib.Headertop>Tjänster – Konsulter</Lib.Headertop>

        <Lib.BigH1>
          Konsulttjänster
        </Lib.BigH1>
      


      <NWD.WebDevParagraphIntro>
        Hos oss hittar ni konsulter med djup teknisk kompetens som också är insiktsfulla och lyhörda
        för verksamhetens behov.
      </NWD.WebDevParagraphIntro>

      {KonsultText.map((text, index) => (
        <NWD.WebDevParagraph key={index}>
          {text}
        </NWD.WebDevParagraph>
      ))}

      <AndtechConsultantSkills />
      <BokaMote
        name="Lena"
        img={LM}
        text="Boka ett möte med {name}."
        email="hello@antech.se"
        subject="Bokningsförfrågan: Möte med Lena"
        body="Hej Lena, Jag är intresserad av att veta mer om era konsulttjänster och skulle gärna boka ett möte med dig."
      />
    </NWD.WebDevSection>
  )
}

